var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlant = function SvgPlant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v3.333A11.25 11.25 0 0 0 15 19.583h3.75v4.167h-7.083c-.69 0-1.25.56-1.25 1.25v6.667A4.584 4.584 0 0 0 15 36.25h10a4.583 4.583 0 0 0 4.583-4.583V25c0-.69-.56-1.25-1.25-1.25H21.25v-2.5H25A11.25 11.25 0 0 0 36.25 10V8.333c0-.69-.56-1.25-1.25-1.25h-5a11.25 11.25 0 0 0-9.198 4.773A11.25 11.25 0 0 0 10 3.75zm16.25 15H25A8.75 8.75 0 0 0 33.75 10v-.417H30a8.75 8.75 0 0 0-8.75 8.75zM18.75 15A8.75 8.75 0 0 0 10 6.25H6.25v2.083a8.75 8.75 0 0 0 8.75 8.75h3.75zm-5.833 11.25v5.417A2.083 2.083 0 0 0 15 33.75h10a2.083 2.083 0 0 0 2.083-2.083V26.25z",
    clipRule: "evenodd"
  })));
};
export default SvgPlant;